import { InjectionToken } from '@angular/core';
import { GalleryImages } from './image-gallery-overlay.service';

export const IMAGE_GALLERY_DIALOG_DATA = new InjectionToken<GalleryImages>('IMAGE_GALLERY_DIALOG_DATA');
